<template>
<!--选做弹框区 -->
  <div class="choose-dialog dialog">
    <el-dialog
      title="选做题"
      :visible="isShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
    >
      <el-form :inline="true" :model="formData" :rules="rulesFrom" ref="formData" class="demo-Form">
        <el-form-item label="大题号：" prop="tihao">
          <el-select v-model="formData.tihao" placeholder="请选择" style="width:100px;" size="small">
            <el-option v-for="item in stide" :key="'th'+item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目名称：" prop="timuName">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="formData.timuName"
            maxlength="50"
            show-word-limit
            style="width:550px;"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="题号：" required>
          <el-row class="input-pading-no">
            <el-col style="width:75px">
              <el-form-item prop="tihaoS">
                <el-input v-model="formData.tihaoS" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="dia-name" style="padding:0 10px;">至</el-col>
            <el-col style="width:75px">
              <el-form-item prop="tihaoE">
                <el-input v-model="formData.tihaoE" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="每题：" prop="fenshuo">
          <el-row class="input-pading-no">
            <el-col style="width:75px;">
              <el-input
                v-model="formData.fenshuo"
                size="small"
                type="number"
                :min="0.5"
                :step="0.5"
              ></el-input>
            </el-col>
            <el-col class="dia-name">分</el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            style="margin-left:15px;"
            @click="addTopic('formData')"
            circle
            size="mini"
          ></el-button>
        </el-form-item>
      </el-form>

      <div class="dialog-cont">
        <el-button type="text" @click="clearList(true)">清空列表</el-button>
        <div class="dialog-list">
          <el-table :data="formData.list" style="width: 100%">
            <el-table-column label="题号">
              <template slot-scope="scope">{{scope.row.tihao}}</template>
            </el-table-column>

            <el-table-column label="分值">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fenshuo" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" style="text-align:center">
              <template slot-scope="scope">
                <el-button type="text" @click="clearList(false,scope)" icon="el-icon-delete"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose" :loading="loading">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="dialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "choose",
  //props: ["isShow", "isEdit", "allIndex"],
 props: ["isShow"],
  computed: {
    ...mapState("cardMake", {
      chooseFrom: state => state.chooseFrom, //
      topicStoreroom: state => state.topicStoreroom,
      answerSheet: state => state.answerSheet,
      topicTh: state => state.answerSheettopicTh,
      isBoxEdit:state=>state.isBoxEdit,
      allIndex:state=>state.allIndex
    })
  },

  data() {
    var tihaoR = (rule, value, callback) => {
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value) {
        callback(new Error("必填"));
      } else if (!validV.test(value)) {
        callback(new Error("请正确填写"));
      } else {
        callback();
      }
    };
    return {
      place: "&nbsp;",
      loading: true,
      formData: {
        tihao: "",
        timuName: "选做题",
        tihaoS: "",
        tihaoE: "",
        fenshuo: "",
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 1,
        dingwei: null //定位
      },
      stide: [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五"
      ], //tihao
      rulesFrom: {
        tihao: [{ required: true, message: "必填", trigger: "blur" }],
        timuName: [{ required: true, message: "必填", trigger: "blur" }],
        tihaoS: [{ validator: tihaoR, trigger: "blur" }],
        tihaoE: [{ validator: tihaoR, trigger: "blur" }],
        fenshuo: [{ required: true, message: "必填", trigger: "blur" }]
      },
      topicThMove: {
        isAdd: false,
        bigTh: [],
        smallTh: []
      }
    };
  },
  created() {
    this.loading = true;
    if (this.isBoxEdit) {
      this.chooseFromMut(
        this.topicStoreroom[this.allIndex.topicIndex].typesItem
      );
    }
    this.formData = JSON.parse(JSON.stringify(this.chooseFrom));
  },
  mounted() {
    this.$nextTick(function() {
      this.loading = false;
    });
  },
  methods: {
    ...mapMutations({
      chooseFromMut: "cardMake/chooseFromMut",
      topicThMut: "cardMake/topicThMut",
      cardLoadingMut: "cardMake/cardLoadingMut",
      chooseDVMut: "cardMake/chooseDVMut",
      isBoxEditMut: "cardMake/isBoxEditMut",
      allIndexMut: "cardMake/allIndexMut",
    }), //参数的变动
    addTopic(formName) {
      this.loading = true;
      let self = this;
      console.log(this.formData, "111");
      this.formData.tihaoS = this.formData.tihaoS.toString();
      this.formData.tihaoE = this.formData.tihaoE.toString();
      this.$refs[formName].validate(valid => {
        if (valid) {
          let s = this.formData.tihaoS.split("."),
            e = this.formData.tihaoE.split(".");
          let isV = true;
          let th = {
            isEdit: this.isBoxEdit,
            bigTh: this.formData.tihao,
            smallTh: []
          };
          if (s.length != e.length ||
          (e.length == 2 &&this.formData.tihaoS.slice(0, 1) !=this.formData.tihaoE.slice(0, 1)) ||
          (e.length == 3 &&this.formData.tihaoS.slice(0, 3) !=this.formData.tihaoE.slice(0, 3)) ||
          parseInt(s[s.length - 1]) > parseInt(e[e.length - 1]) ||
            s.length > 3 ||
            e.length > 3
          ) {
            isV = false;
          }

          if (!isV) {
            this.$message({
              message: "开始题号和结束题号不正确",
              type: "warning"
            });
            this.loading = false;
            return;
          }
          let chazhi = e[e.length - 1] - s[s.length - 1];
          let curList = [];

          for (let v = 0; v < chazhi + 1; v++) {
            let th1 = parseInt(s[s.length - 1]) + v;
            if (s.length > 1) {
              if (s.length - 2 == 0) {
                th1 = this.formData.tihaoS.slice(0, 1) + "." + th1;
              } else {
                th1 = this.formData.tihaoS.slice(0, 3) + "." + th1;
              }
            }
            this.formData.list.forEach(o => {
              if (o.thList.indexOf(th1)!=-1) {
                isV = false;
                return;
              }
            });
            if (!isV) {
              this.$message({
                message: "本题设置的小题号已经存在",
                type: "warning"
              });
              this.loading = false;
              return;
            }
            th.smallTh.push(th1);
            
          }
          let curD = {
              tihao: `${this.formData.tihaoS}-${this.formData.tihaoE}`,
              thList:th.smallTh,
              fenshuo: this.formData.fenshuo
            };
            curList.push(curD);
          
        } else {
          console.log("error submit!!");
        }

        //this.loading = false;
        setTimeout(function() {
          self.$nextTick(function() {
            self.loading = false;
          });
        }, 0);
      });
    }, //添加小题

    clearList(isAll, scope) {
      console.log(isAll, scope, "scope");
      if (this.isBoxEdit) {
        if (isAll) {
          let th = {
            isAdd: false,
            bigTh: this.formData.tihao,
            smallTh: []
          };
          this.topicThMove.bigTh.push(th.bigTh);
          this.formData.list.forEach(t => {
            th.smallTh.concat(t.thList);
            this.topicThMove.smallTh.concat(t.tihao);
          });
          this.topicThMut(th);
          this.formData.list = [];
          this.formData.tihaoS = "";
          this.formData.tihaoE = "";
        } else {
          let th = {
            isAdd: false,
            bigTh: "",
            smallTh: scope.row.thList
          };
          if (this.formData.list.length == 1) {
            th.bigTh = this.formData.tihao;
            this.topicThMove.bigTh.push(this.formData.tihao);
          }
          this.topicThMove.smallTh.concat(scope.row.tihao);
          this.topicThMut(th);
          this.formData.list.splice(scope.$index, 1);

          if (this.formData.list.length > 1) {
            this.formData.tihaoS = this.formData.list[this.formData.list.length-1].thList[0];
            this.formData.tihaoE = this.formData.list[this.formData.list.length - 1].thList[this.formData.list[this.formData.list.length - 1].thList.length-1];
          } else if (this.formData.list.length == 1) {
            this.formData.tihaoS = this.formData.list[0].thList[0];
            this.formData.tihaoE = this.formData.list[0].thList[this.formData.list[0].thList[0].length-1];
          }
        }
      } else {
        if (isAll) {
          this.formData.list = [];
        } else {
          this.formData.list.splice(scope.$index, 1);
          if (this.formData.list.length > 1) {
            this.formData.tihaoS = this.formData.list[this.formData.list.length-1].thList[0];
            this.formData.tihaoE = this.formData.list[this.formData.list.length-1].thList[this.formData.list[this.formData.list.length - 1].thList.length-1];
          } else if (this.formData.list.length == 1) {
            this.formData.tihaoS = this.formData.list[0].thList[0];
            this.formData.tihaoE = this.formData.list[0].thList[this.formData.list[0].thList.length-1];
          }
        }
      }
    }, //清空列表
    dialogClose() {
      //this.$emit("update:isShow", false); //触发 input 事件，并传入新值
      this.chooseDVMut(false)
      if (
        this.topicThMove.bigTh.length > 0 ||
        this.topicThMove.smallTh.length > 0
      ) {
        this.topicThMut(this.topicThMove);
        this.topicThMove.bigTh = [];
        this.topicThMove.smallTh = [];
      }
      this.chooseFromMut({});
    },
    dialogSubmit() {
      this.cardLoadingMut(true);
      if (this.formData.list.length > 0) {
        let hTotal = 40 + 2 + 10,
          curGroupArry = [],
          th = { bigTh: this.formData.tihao, smallTh: [] };

        this.formData.list.forEach((data,i) => {
          let gA = {
            thList:data.thList,
            tihao:data.tihao,
            groupNum: 8, //此题默认8行
            sty:0,//默认是无线的
            rowH: 200+22, //一行的高度，i==0?(200-2-20):(200-1-20)
            //rowH:2000+22,
            htmlCont: `<p>${data.tihao}.(${data.fenshuo}分)</p>`, //一个块点一个位置
            isEdit: false,
            topicInPageIndex:i,//当前项的索引，后面跟着变
            resolveEnd: true,//是否是分解部分
            isMoveN: false,//向下移动到边缘标识
            isMoveP: false,//向上移动到边缘标识
            isfenzhi: i == 0 ? false : true,//是不是解答题分支
            itemInTopicIndex:i//题库里面的总体索引，不变作为查找对比使用
          };
          // let curP=''
          // data.thList.forEach((p,gth)=>{
          //   curP+=`<span class="tukuangTh">${gth}<i class="tukuang"></i></span>`
          // })
          // gA.htmlCont=`<p class="topic-desc">选做题目:${curP}<p>`+`<p>${data.tihao}.(${data.fenshuo}分)</p>`
          curGroupArry.push(gA);
          hTotal += 200;
          th.smallTh.concat(data.thList);
          this.formData.fsTotal += parseFloat(data.fenshuo);
        });
        this.formData.groupHArry = curGroupArry;
        this.chooseFromMut(this.formData);
      } else {
        this.$message({
          message: "请设置题目",
          type: "warning"
        });
      }
    } //确定大型设置完成
  },
  watch: {
    '$store.state.cardMake.chooseDV': function(newV, oldV) {
      if (this.isBoxEdit) {
        this.$set(
          this,
          "formData",
          this.topicStoreroom[this.allIndex.topicIndex].typesItem
        );
      } else {
        this.$set(
          this,
          "formData",
          JSON.parse(JSON.stringify(this.chooseFrom))
        );
      }
      this.$nextTick(function() {
        this.loading = false;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
